import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Lightning, EnvelopeSimple } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0B] grain px-4">
      <div className="w-full max-w-md relative z-[2]">
        <Link to="/" className="flex items-center gap-2.5 mb-10 justify-center">
          <div className="w-9 h-9 border border-[#00F0FF] flex items-center justify-center">
            <Lightning size={20} weight="fill" className="text-[#00F0FF]" />
          </div>
          <span className="font-semibold tracking-tight text-lg">MDM Forge</span>
        </Link>

        <div className="border border-[#27272A] bg-[#121214] p-8">
          {sent ? (
            <div className="text-center" data-testid="forgot-sent">
              <div className="w-12 h-12 border border-[#00FF41] flex items-center justify-center mx-auto mb-4">
                <EnvelopeSimple size={24} className="text-[#00FF41]" />
              </div>
              <h1 className="text-xl tracking-tight mb-2">Check your inbox</h1>
              <p className="text-sm text-[#A1A1AA] font-mono leading-relaxed">
                If an account exists for <span className="text-[#FAFAFA]">{email}</span>, a reset link is on its way.
              </p>
              <Link to="/login" className="inline-block mt-6 text-sm text-[#00F0FF] hover:underline font-mono">
                Back to sign in
              </Link>
            </div>
          ) : (
            <>
              <h1 className="text-2xl tracking-tight mb-1">Forgot password</h1>
              <p className="text-sm text-[#A1A1AA] mb-6 font-mono">We'll email you a reset link</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label className="block text-xs text-[#A1A1AA] mb-1.5 font-mono">EMAIL</label>
                  <input
                    data-testid="forgot-email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full bg-[#0A0A0B] border border-[#27272A] px-3 py-2.5 text-sm font-mono focus:border-[#00F0FF] focus:outline-none transition-colors duration-200"
                    placeholder="you@company.com"
                  />
                </div>
                {error && (
                  <div data-testid="forgot-error" className="text-xs text-[#FF5F56] font-mono border border-[#FF5F56]/30 bg-[#FF5F56]/5 px-3 py-2">
                    {error}
                  </div>
                )}
                <button
                  data-testid="forgot-submit"
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#00F0FF] text-[#0A0A0B] font-medium py-2.5 text-sm hover:bg-[#00d4e0] transition-colors duration-200 disabled:opacity-50"
                >
                  {loading ? "Sending…" : "Send reset link"}
                </button>
              </form>
              <p className="text-xs text-[#71717A] mt-6 text-center font-mono">
                <Link to="/login" data-testid="back-to-login" className="text-[#00F0FF] hover:underline">
                  Back to sign in
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
